export const decodeSeoUrl = (urlToDecode: string): string => {
    return btoa(
        encodeURIComponent(urlToDecode).replace(/%([0-9A-F]{2})/g, function (_match, p1) {
            // @ts-ignore
            return String.fromCharCode('0x' + p1)
        })
    )
}
